import type { Language } from "@marshmallow-duel/simulation";

const en: readonly string[] = [
  "Jump boots", "Death skull", "Mine", "Jetpack", "Floater", "Teleport", "Homing rocket", "Water walk I",
  "Faster run", "Invisibility", "Flash", "Laser beam", "Cluster mine", "Explosion", "Slower run", "Explosive projectile",
  "Stun projectile", "Reverse controls", "Random ability", "Fireball", "Grenade", "Super shield", "Frog", "Floor destroyer",
  "Bomber", "Destruction star", "Time slowdown", "Freezer ball", "No ability", "Guided projectile", "Bomb", "Disappearing walls",
  "Flame", "Teleport projectile", "Freeze", "Pistol", "New walls", "Water walk II", "Destroy death skull", "Wall destroyer",
  "Hover ball", "No rope", "Running bomb", "Parachute", "Weasel", "Net", "Magnet", "Flamethrower"
];

const cz: readonly string[] = [
  "Skákací boty", "Lebka smrti", "Nástražná mina", "Jetpack", "Vznášeč", "Teleport", "Naváděná raketa", "Chůze ve vodě I",
  "Rychlejší běh", "Neviditelnost", "Blesk", "Paprsek laseru", "Výbušná mina", "Výbuch", "Pomalejší běh", "Vybuchující střela",
  "Omračující střela", "Opačné ovládání", "Náhodná schopnost", "Ohnivá koule", "Granát", "Super štít", "Žába", "Střela pod sebe",
  "Střela před sebe", "Hvězda zničení", "Zpomalení času", "Mrazivá koule", "Žádná schopnost", "Řízená střela", "Bomba", "Mizení zdí",
  "Plamen", "Teleportační střela", "Zmražení", "Pistole", "Nové zdi", "Chůze ve vodě II", "Zničení lebky smrti", "Ničitel zdí",
  "Vznášející koule", "Zákaz lana", "Jezdící bomba", "Padák", "Lasička", "Síť", "Magnet", "Vystřelovač plamenů"
];

export const abilityName = (language: Language, id: number): string => (language === "cz" ? cz : en)[id - 1] ?? String(id);
